import React from 'react';
import logo from '../assets/images/logo.png';
import previewApp from '../assets/images/ourapp.png';
import { useRedirect } from '../hooks/useRedirect';
import { FaArrowLeft } from 'react-icons/fa6';

type RegistrationContentProps = {
  path?: string;
  setPage?: (path: number) => void;
  switchIndex?: number;
  handlePageBack?: () => void;
}

const RegistrationContent = ({ path, setPage, switchIndex, handlePageBack }: RegistrationContentProps) => {
  const navigate = useRedirect();
  return (
    <div className="bg-[#6833ff] background w-full h-[450px] sm:h-[550px] lg:h-screen overflow-hidden relative">
        <div className="container mx-auto px-4 lg:px-10 mt-8 text-white">
          <div className='flex-col items-center justify-between'>
            <div>
              <div className="flex items-center justify-between">
                <img src={logo} alt="logo" className="w-[100px] sm:w-[200px]" />
              <div onClick={() => {
                if (handlePageBack) {
                  handlePageBack();
                  return;
                }
                if (setPage && switchIndex) {
                  setPage(switchIndex)
                } else {
                  path && navigate(path)
                }
              }} className="w-8 h-8 rounded-full bg-white flex items-center justify-center cursor-pointer lg:hidden text-black">
                  <FaArrowLeft/>
                </div>
              </div>
              <h1 className="text-2xl lg:text-6xl font-medium text-center lg:text-start leading-tight mt-10 lg:w-[600px]">
                Make your content
                translation cheaper
                and much easier
              </h1>
              <p className="text-xs md:text-xl lg:text-xl mt-4 text-center lg:text-start">Save over 90% of the workload stress of social <br /> media accounts management efforts. </p>
            </div>
            <img className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-[400px] sm:w-[550px] lg:w-[650px] md:mx-auto" src={previewApp} alt="previewApp" />
          </div>
        </div>
      </div>
  );
};

export default RegistrationContent;